import { BooleanPointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../constants';

export default (): BooleanPointerParameterValue => ({
  type: PARAMETER_VALUE_TYPE.BOOLEAN_POINTER,
  variable: null,
});
